export const BUYER_NOT_IN_GROUP_CODE = 25013
